import { Modal as antdModal } from 'antd'
import useModal, { type HookAPI } from 'antd/es/modal/useModal'

/** @ts-ignore */
export let modal: HookAPI = antdModal

export function GlobalModal() {
  const [modalApi, contextHolder] = useModal()

  modal = modalApi

  return <>{contextHolder}</>
}

export function useGlobalModal() {
  if (!modal) {
    throw new Error('GlobalModal not mounted on root')
  }
  return modal
}
